module.exports = __webpack_public_path__ + "img/bCollection.021f9089.svg";